import React from 'react'
import Footer from '../Footer'
import NavBar from '../NavBar'
import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Container, Row ,Card} from 'react-bootstrap'
// import bgimage from '../DetailsProduct/imeages/bgimage.jpg'
// import imege2  from '../DetailsProduct/imeages/limisimage.png'
import imege1 from '../DetailsProduct/imeages/bloodbank.avif' 
import { FaUserPlus, FaMicroscope, FaClipboardList, FaServer, FaDatabase, FaProjectDiagram, FaLaptopCode } from "react-icons/fa";
import {FaComputer } from "react-icons/fa6";
import '../App.css'
import { useTheme } from '../ThemeContext';

const BloodBank = () => {
  const models = [
    { title: "DONOR REGISTRATION", text: "Capture exhaustive information from donors for better traceability", icon: <FaUserPlus size={30} color='' /> },
    { title: "PRE SCREENING", text: "Robust Prescreening process to fulfill blood requests from various sources", icon: <FaMicroscope size={30} /> },
    { title: "ORDER CONSOLIDATION", text: "Consolidate blood requests from multiple sources", icon: <FaClipboardList size={30} /> },
    { title: "DIGITAL CROSS MATCHING", text: "Run Cross Match Test on pre-defined rules & honor blood requests", icon: <FaServer size={30} /> },
    { title: "INTEGRATED INVENTORY", text: "Monitor Requests & Issues Real-time, honor blood requests on time", icon: <FaDatabase size={30} /> },
    { title: "Seamless 3rd Party Communication", text: "Easy Integration with all lab device manufacturers", icon: <FaProjectDiagram size={30} /> },
  ];;

  const sections = [
    {
      title: "Front End",
      icon: <FaLaptopCode size={50} style={{ opacity: 0.7 }}/>,
      points: [
        "Angular 14 & HTML5 with continuous upgrade to latest versions",
        "Faster, Scalable, enabling Easy Adoption",
      ],
    },
    {
      title: "Server Side",
      icon: <FaComputer size={50} style={{ opacity: 0.7 }} />,
      points: [
        "Web API, .Net Core MVC",
        "Improved Performance of Application, Scalable & Robust",
      ],
    },
    {
      title: "Back End",
      icon: <FaDatabase size={50} style={{ opacity: 0.7 }} />,
      points: [
        "SQL-Scalable and Elastic Infrastructure",
        "In-built Features for enhanced data security",
      ],
    },
  ];
  const {theme} = useTheme()
  return (
    <div style={{
        backgroundColor: theme === "dark" ? "#1e1e1e" : "",
        minHeight: "100vh", marginTop:'40px'
      }}>
        <NavBar />
        
        <Container fluid className="py-5"
     style={{
      // backgroundImage:`url(${bgimage})`,
      backgroundImage: theme === "light" ?"" : "none",
      backgroundColor: theme === "dark" ? "#1e1e1e" : "none",
      backgroundSize: 'cover', 
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backdropFilter:'blur(10px)'
    }}
    >
      <Container>
        <Row className="d-flex justify-content-center align-items-center">
          {/* Text Section */}
          <Col xs={12} md={6}  className="text-center text-md-start ">
            <h1 className="fw-bold  text-decoration-underline">
            

Hospital Information System <br />
              <span></span>
            </h1>
            <h4 className="text-primary mt-3 fw-bold">BBT Labs</h4>
            <p className='fs-4'>
            BBT Labs is certified by 3 rd party VAPT Agencies on <br />
            potential vulnerabilities & external threats. We take <br />
            our Patients Data Seriously and it is 100% Safe % Secure.
            </p>
            
          </Col>

          {/* Image Section */}
          <Col xs={12} md={6} className="text-center align-items-start">
            <img
             style={{marginTop:'10%',marginRight:'20%',width:"400px",height:"400px",objectFit:"cover" }}
                           src={imege1} 
                           alt="Scientist illustration"
                           className="rounded-circle img-fluid mx-auto d-block"
              // style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain" }}
            />
          </Col>
        </Row>
      </Container>

      <Container>
        <h4 className='text-center text-primary py-5'>HIGH LEVEL MODELS </h4>
        <Row className="justify-content-center">
        {models.map((model, index) => (
          <Col md={5} sm={12} key={index} className="mb-4">
            <Card className="d-flex flex-row align-items-center shadow-sm p-3 "style={{borderTopLeftRadius:'50px',borderBottomLeftRadius:'50px',minHeight:'150px'}}>
              <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center" style={{ width: "50px", height: "50px", fontSize: "1.5rem" }}>
                {model.icon}
              </div>
              <div className="ms-3">
                <h5 className="mb-1">{model.title}</h5>
                <p className="mb-0 text-muted">{model.text}</p>
              </div>
            </Card>
          </Col>
        ))}
      </Row>

  </Container>
  <Container fluid >
              <h2 className='text-primary text-pperase text-center '>TECHNOLOGY STACK </h2>
              
              <Row className="justify-content-center">
              {sections.map((section,index)=>(
                 <Col md={4} xs={12} key={index}  className='mb-2'  >
                    <Card className='shadow-sm border-0' style={{minHeight:'230px'}}>
                      <Card.Header className='text-center text-dark fw-bold fs-5'>
                        {section.icon}
                        {/* {section.title} */}
                      </Card.Header>
                                               <h5 className='fw-bold mt-3 ms-4'>{section.title}</h5>

                      <Card.Body>
                        <ul className='list-unstyled'>
                          {section.points.map((item,idx)=>(
                            <li key={idx}>➤ {item}</li>
                          ))}
                        </ul>
                      </Card.Body>
                    </Card>

                 </Col>
              ))}

                

              </Row>

     </Container>
     </Container>

     <Footer />
        </div>
  )
}

export default BloodBank